import { useDayPicker, Week, WeekProps } from '@daypicker/react'
import { day, isSame, isWeekend } from 'astra'

type ExpandedWeekProps = WeekProps & {
    hideDuplicateWeeks?: boolean
    weekdaysOnly?: boolean
    showOutsideDays?: boolean
    fixedWeeks?: boolean
}

function getISOWeekKey(date: Date): string {
    const d = day(date)
    return `${d.isoWeekYear()}-${d.isoWeek()}`
}

function ownsISOWeek(week: WeekProps['week'], months: ReturnType<typeof useDayPicker>['months']): boolean {
    const firstDay = week.days[0]
    if (!firstDay) return true

    const weekKey = getISOWeekKey(firstDay.date)
    const ownerMonth = months.find(month => month.weeks.some(w => w.days[0] && getISOWeekKey(w.days[0].date) === weekKey))

    return !ownerMonth || isSame(day(ownerMonth.date), firstDay.displayMonth, 'month')
}

export const AstraDayPickerWeek = ({ hideDuplicateWeeks, weekdaysOnly, showOutsideDays, fixedWeeks, ...rest }: ExpandedWeekProps) => {
    const { months } = useDayPicker()
    const { days } = rest.week

    if (hideDuplicateWeeks && !ownsISOWeek(rest.week, months)) return <></>

    if (fixedWeeks) return <tr {...rest} />
    if (weekdaysOnly && !showOutsideDays) {
        return days.filter(d => !isWeekend(day(d.date))).every(day => day.outside) ? <></> : <Week {...rest} />
    }
    return <Week {...rest} />
}
